import YYModal from './modal.js'

let ModalInstance

function getModalInstance(options) {
    ModalInstance = ModalInstance || YYModal.newInstance(options)
    return ModalInstance
}

YYModal.show = (options) => {
    options.onRemove = function () {
        ModalInstance = null
    }
    const instance = getModalInstance(options)
    instance.show()
}

YYModal.hide =  () => {
    if (!ModalInstance) {
        return false
    }
    const instance = getModalInstance()
    instance.hide()
}

export default YYModal